import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';

@Injectable()
export class AdmManageUniversalOperationalHoursService {

  constructor(private _httpClient: IesHttpClient) {
  }

  getUniversalOperationalHours() {
    return this._httpClient.get(AppUrl.getUniversalOperationalHours);
  }

  updateUniversalOperationalHours(params: any) {
    return this._httpClient.put(AppUrl.updateUniversalOperationalHours, params);
  }

}




// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-universal-operational-hours/adm-manage-universal-operational-hours.service.ts